// The survey's Results page: renders ResultsPage under the survey layout.

import { createFileRoute } from "@tanstack/react-router";
import { useSurvey } from "@/api/surveys";
import { ResultsPage } from "@/features/results/results-page";

export const Route = createFileRoute("/w/$workspaceId/surveys/$surveyId/results")({
    component: SurveyResultsRoute,
});

function SurveyResultsRoute() {
    const { workspaceId, surveyId } = Route.useParams();
    const survey = useSurvey(surveyId).data;
    // The layout above already gated loading/not-found on the same query key.
    if (!survey) return null;
    return <ResultsPage survey={survey} workspaceId={workspaceId} />;
}
